import { EditableGrowingInput, OverflowText, TooltipWrapper } from "@theorgchartdev/storybook";
import cx from "classnames";
import React, { Fragment } from "react";
import { useRenameDocController } from "@/hooks/useRenameDocController";
import { GetWSMgr } from "@/Utils/StateLib";
import { enumDataSource } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

export const RenameDocInput = props => {
  const { canEdit, SaveSettings, nameInputRef, GetDisplayName } = useRenameDocController();
  const wsMgr = GetWSMgr();
  const docMgr = wsMgr?.GetDocMgr();
  const iWiz = docMgr?.GetIWizDataRefresh();

  let displayName = docMgr?.GetFormattedChartName(false, false);

  const renameActive = props?.handleRef?.current?.editMode;
  const showDirty = wsMgr?.ReadyToSave() && !docMgr?.IsAutoSaveEnabled();
  const renameClass = "oc-main-name-input";

  return (
    <Fragment>
      {canEdit() ? (
        <TooltipWrapper tooltipProps={{ message: appstr("Rename") }}>
          <div className={cx(renameClass, !renameActive && showDirty && `${renameClass}--italic`)}>
            <EditableGrowingInput
              dataTestId={"oc-rename-input"}
              size={"large"}
              ref={nameInputRef}
              handleRef={props?.handleRef}
              text={renameActive ? GetDisplayName() : displayName}
              onChange={() => SaveSettings()}
            />
          </div>
        </TooltipWrapper>
      ) : (
        <div className={renameClass}>
          <OverflowText size={"large"} modifier={"medium"}>
            {displayName}
          </OverflowText>
        </div>
      )}
    </Fragment>
  );
};
